import { PrivacyPolicyAggregate } from 'src/app/models/privacy-policy/privacy-policy-aggregate';
import { TermsOfServiceAggregate } from 'src/app/models/terms-of-service/terms-of-service-aggregate';
import { TermsOfServiceUrl } from 'src/app/models/terms-of-service/terms-of-service-url';
import { TermsOfServiceVersion } from 'src/app/models/terms-of-service/terms-of-service-version';

export class TermsOfServiceViewModel {
  readonly version: TermsOfServiceVersion;
  readonly url: TermsOfServiceUrl;
  constructor(private readonly params: TermsOfServiceAggregate) {
    this.version = params.version;
    this.url = params.url;
  }
}
